import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {ProductLineItem} from '../types';
import {
    useNavigate,
    useParams
} from "react-router-dom";
import {stage} from "../../../config/stage";
import {Product} from "../../products/types.ts";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<Product, 'id'>,
    handleSubmit: (values: ProductLineItem) => void
}) => {
    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('productId is required parameter')
    }

    const navigate = useNavigate()

    const onSubmit = (values: ProductLineItem) => {

        values.productId = productId

        handleSubmit(values);
        navigate(`/products/${productId}`);
    };

    const onCancel = () => {
        navigate(`/products/${productId}`);
    };


    let initialValues = {} as ProductLineItem;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
